export function getReshippingPayerValue(order: any): number {
  if (order?.origin !== 'REENVIO') return 0

  return parseFloat(order?.reshipping_payer_value ?? 0) || 0
}

export function getPayableAmount(order: any): number {
  const payerValue = getReshippingPayerValue(order)

  if (payerValue > 0) return payerValue

  return parseFloat(order?.amount ?? 0) || 0
}
